import React, { useEffect, useState } from "react";
import { pxToRem } from "@/util/common";
import { createUseStyles } from "react-jss";
import { Image, InfiniteScroll, PullToRefresh, SearchBar } from "antd-mobile";
import useRouter from "@/hooks/useRouter";
import API from "@/api";
import InfiniteScrollContent from "@/components/InfiniteScrollContent";
import CustomEmpty from "@/components/Empty";
import useCustomTranslation from "@/hooks/useTranslation";
import TinyChens from "@/components/tinyChen/list";

const SearchResult: React.FC = () => {
	const classes = useStyles();
	const { t } = useCustomTranslation();
	const { goBack } = useRouter();
	const [value, setValue] = useState("");
	const [membersData, setMembersData] = useState<any[]>([]);
	const [hasMore, setHasMore] = useState(true);
	const [page, setPage] = useState(0);

	const pageSize = 40;
	const postFinanceAccountMemberSearchHandle = async (isRefresh = false) => {
		try {
			let pageNum = isRefresh ? 0 : page;
			const params: any = {
				page: pageNum,
				pageSize: pageSize,
				nickname: value,
			};
			const result: any =
				await API.finances.apiFinanceAccountMemberSearch(params);
			if (result?.code === 0) {
				const contentData = result.content.data ?? [];
				const haveMore = result.content.haveMore ?? false;
				setHasMore(haveMore);
				if (haveMore) {
					if (isRefresh) {
						setPage(1);
					} else {
						setPage((prevPage) => prevPage + 1);
					}
				}
				if (pageNum === 0) {
					setMembersData(contentData);
				} else {
					setMembersData((prevData) => [...prevData, ...contentData]);
				}
			}
		} catch (error) {
			console.log("---apiFinanceAgentHomeMember--:", error);
		}
	};
	const handleRefresh = async () => {
		await postFinanceAccountMemberSearchHandle(true);
	};

	const handleFetchMore = async () => {
		await postFinanceAccountMemberSearchHandle();
	};

	useEffect(() => {
		postFinanceAccountMemberSearchHandle();
	}, []);

	return (
		<div className="router-main">
			<div className={classes.searchNavWrap}>
				<div onClick={() => goBack()} className="back">
					<Image
						src={require("@/assets/images/icons/back.png")}
						width={20}
						height={18}
					/>
				</div>
				<div className="search">
					<SearchBar
						value={value}
						placeholder="Search"
						style={{
							fontSize: pxToRem(12),
							fontWeight: "400",
							color: "#FFFFFF",
							"--border-radius": pxToRem(40),
							"--height": pxToRem(36),
							"--background": "#1E212B",
							"--placeholder-color": "#868FA8",
						}}
						icon={
							<Image
								src={require("@/assets/images/icons/search.png")}
								width={22}
								height={22}
							/>
						}
						onChange={(val: string) => {
							setValue(val);
						}}
						onSearch={() => handleRefresh()}
					/>
				</div>
			</div>
			<div className="router-view">
				<div className={classes.searchResultWrap}>
					<PullToRefresh
						onRefresh={handleRefresh}
						canReleaseText={t("canReleaseText")}
						completeText={t("completeText")}
						pullingText={t("pullingText")}
						refreshingText={t("refreshingText")}
					>
						{membersData.length === 0 ? (
							<CustomEmpty />
						) : (
							<TinyChens
								membersData={membersData}
								profit={t("DaysTotalProfit")}
							/>
						)}
						{membersData.length > 0 && (
							<InfiniteScroll
								loadMore={handleFetchMore}
								hasMore={hasMore}
							>
								<InfiniteScrollContent hasMore={hasMore} />
							</InfiniteScroll>
						)}
					</PullToRefresh>
				</div>
			</div>
		</div>
	);
};

export default SearchResult;

const useStyles = createUseStyles({
	searchNavWrap: {
		display: "flex",
		alignItems: "center",
		padding: {
			top: pxToRem(16),
			bottom: pxToRem(16),
			right: pxToRem(20),
		},
		borderBottom: "1px solid #2F3A62",
		"& .back": {
			padding: {
				left: pxToRem(20),
				right: pxToRem(20),
			},
		},
		"& .search": {
			flex: 1,
			border: "1px solid #4C66C7",
			borderRadius: pxToRem(40),
			"--adm-color-background": "#1E212B",
			"& .adm-input-element": {
				"--color": "#FFFFFF",
			},
		},
	},
	searchResultWrap: {
		padding: {
			top: pxToRem(20),
			left: pxToRem(20),
			right: pxToRem(20),
			bottom: pxToRem(30),
		},
	},
});
